import { render, staticRenderFns } from "./TheOrderInfo.vue?vue&type=template&id=5b4121f0&"
import script from "./TheOrderInfo.vue?vue&type=script&lang=js&"
export * from "./TheOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./TheOrderInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports